module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAARUlEQVQ4y2P4jwQ+MAww7wADDNgPPI//D5gxKHhgV/H//z9IeBChwcEDMpj/DwYePyQRMwwKHij1/P8zKHiDKE8PnrIOAN1hkPV0+xeKAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQyKzA5OjAw33rQQQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00148_100x100.png
// module id = YSZ5
// module chunks = 0